import React from 'react'
import {AiFillHeart} from "react-icons/ai"
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
  return (
    <div className=' h-20 sm:h-24 mt-24 bg-slate-700'>
    <div className='w-full  h-10 sm:h-20 items-center flex justify-center '>
    <h1 className='text-center  text-gray-200 font-bold'>Hecho por Yeremi Araya</h1>
    <AiFillHeart className='ml-2 text-red-800'/> 
    
  </div>
    <div className='flex  justify-center items-center sm:hidden'>
      <a className='text-gray-300 ' href='https://github.com/Yeremi528' target='_blank'><GitHubIcon/> </a>
      <a  className='text-gray-300 ml-2' href='https://www.instagram.com/alej4ndro0o/?hl=es-la' target='_blank'><InstagramIcon/></a>
      
      
    </div>
  </div>
  )
}

export default Footer